import React from 'react';

const CategoryCardSkeleton: React.FC = () => {
  return (
    <div className="flex-shrink-0 w-[250px] bg-white dark:bg-xervix-bg-secondary-dark rounded-xl shadow-lg overflow-hidden mx-4 animate-pulse">
      {/* Imagen de la categoría (skeleton) */}
      <div className="h-[160px] bg-gray-200 dark:bg-gray-700"></div>
      
      {/* Contenido de la categoría (skeleton) */}
      <div className="p-3">
        {/* Nombre de la categoría y contador */}
        <div className='flex justify-between items-center mb-4'>
          <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-24"></div>
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-16"></div>
        </div>
        
        {/* Servicios destacados */}
        <div className="mb-4">
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-32 mb-2"></div>
          <div className="space-y-2">
            <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-full"></div>
            <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-full"></div>
            <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-3/4"></div>
          </div>
        </div>
        
        {/* Botón */}
        <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-24 mx-auto"></div>
      </div>
    </div>
  );
};

export default CategoryCardSkeleton;
